/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const FORM_DATA = [
    {
        label: "Select Item Collection Id",
        name: "qrBatchId",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: []
        }
    },
    {
        label: "Lower Limit",
        name: "lowerBound",
        type: "number-input",
        fieldProps: {}
    },
    {
        label: "Upper Limit",
        name: "upperBound",
        type: "number-input",
        fieldProps: {}
    },
    {
        label: "Select Product",
        name: "productId",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: []
        }
    },
    {
        label: "Select Barcode",
        name: "gtinId",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: []
        }
    },
    {
        label: "Select Product BatchId",
        name: "productBatchId",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: []
        }
    },
    {
        label: "Description",
        name: "description",
        type: "text-area",
        fieldProps: {}
    },

]

export const FIELDS: any ={
    qrBatchId: {
        validators: {
            notEmpty: {
                message: "QR Batch is required"
            },

        }
    },
    productId: {
        validators: {
            notEmpty: {
                message: "Product is required"
            },

        }
    },
    gtinId: {
        validators: {
            notEmpty: {
                message: "GTIN is required"
            },

        }
    },
    lowerBound: {
        validators: {
            notEmpty: {
                message: "Lower Bound is required"
            },

        }
    },
    upperBound: {
        validators: {
            notEmpty: {
                message: "Upper Bound is required"
            },

        }
    },
}